module.exports = __webpack_public_path__ + "static/media/summer.ac2ab6b2.png";